<template>
  <section class="confirmation-order-details">
    <h3>{{ $t('confirmation.orderDetails') }}</h3>
    <p>{{ name }}</p>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-html="fullAddress" />
    <p class="phone">
      <strong>{{ $t('confirmation.phone') }}:</strong>
      {{ phoneNumber }}
    </p>
    <p class="event-name">
      <strong>{{ $t('confirmation.eventName') }}:</strong>
      &nbsp;{{ displayName }}
    </p>
    <div class="confirmation-order-items">
      <div
        v-for="(item, index) in orderItems"
        :key="index"
        class="item-details"
      >
        <p>
          <strong>{{ $t('confirmation.item') }}:</strong>
          {{ item.event_name }} - {{ item.package_name }}
        </p>
        <p>
          <strong>{{ $t('confirmation.quantity') }}:</strong>
          {{ item.quantity }}
        </p>
        <div
          v-for="(hotel, i) in getHotels(item)"
          :key="i"
          class="hotel-item-details"
        >
          <p>
            <strong>{{ $t('confirmation.item') }}:</strong>
            {{ item.hotel_name }}
          </p>
          <p
            v-if="item.room_type"
          >
            <strong>{{ $t('confirmation.roomType') }}:</strong>
            {{ item.room_type_translated }}
          </p>
          <p>
            <strong>{{ $t('confirmation.reservationName') }}:</strong>
            {{ hotel.name }}
          </p>
          <p>
            <strong>{{ $t('confirmation.quantity') }}:</strong>
            {{ hotel.room_quantity }}
          </p>
        </div>
      </div>
    </div>
    <div class="confirmation-totals">
      <p class="subtotal">
        <strong>{{ $t('confirmation.subtotal') }}:</strong>
        &nbsp;{{ subtotal }}
      </p>
      <p class="processing-fee">
        <strong>{{ $t('confirmation.processingFee') }}:</strong>
        &nbsp;{{ processingFee }}
      </p>
      <p class="charge-currency">
        <strong>{{ $t('confirmation.currency') }}:</strong>
        &nbsp;{{ chargeCurrency }}
      </p>
      <p class="total">
        <strong>{{ $t('confirmation.total') }}:</strong>
        &nbsp;{{ total }}
      </p>
    </div>
  </section>
</template>

<script>
import FetchCall from '../local_fetch_call'
export default {
  data() {
    return {
      name: '',
      fullAddress: '',
      phoneNumber: '',
      displayName: '',
      orderItems: [],
      subtotal: '',
      processingFee: '',
      chargeCurrency: '',
      total: ''
    }
  },

  async mounted() {
    let el = document.getElementById('DataId').dataset
    this.name = el.name
    this.fullAddress = el.full_address
    this.phoneNumber = el.phone_number
    this.displayName = el.display_name
    this.subtotal = el.subtotal
    this.processingFee = el.processing_fee
    this.chargeCurrency = el.charge_currency
    this.total = el.total

    let res = await FetchCall.fetchWithoutLocale(
      `/api/order_items?order_id=${el.order_id}`,
      'GET',
      null
    )

    this.orderItems = res.order_items
  },

  methods: {
    getHotels(item) {
      if (!item.hotel_id) return

      let uniqueRes = [...new Set(item.reservations)]
      let hotelArr = new Array()
      uniqueRes.forEach(name => {
        let room_quantity = item.reservations.filter(x => x === name).length
        hotelArr.push({
          name,
          room_quantity,
        })
      })

      return hotelArr
    }
  }

}
</script>
